export default {
  emptyTeam: 'You have no team',
};
